import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LazyLoadEvent } from 'primeng/api';
import { NdmsSafeSubscriber } from '../../../../../../shared/core/interfaces/ndms-safe-subscriber';
import { ToastService } from '../../../../../../shared/core/services/toast.service';
import { SearchCourseComponent } from '../search-course/search-course.component';
import { CourseService } from '../../../../api/services/course.service';
import { CourseModel } from '../../../../api/models/course-model';
import { FindFilter } from '../../../../api/models/find-filter';

@Component({
  selector: 'search-courses-modal',
  templateUrl: './search-courses-modal.component.html',
  styleUrls: ['./search-courses-modal.component.css']
})
export class SearchCoursesModalComponent extends NdmsSafeSubscriber implements OnInit {
  @ViewChild(SearchCourseComponent) searchCourse: SearchCourseComponent;

  private _itemList$: BehaviorSubject<CourseModel[]> = new BehaviorSubject<CourseModel[]>([]);
  get itemList$() {
    return this._itemList$.asObservable();
  }
  get itemList() {
    return this._itemList$.value;
  }
  
  private _count$ = new BehaviorSubject<number>(0);
  get count$() {
    return this._count$.asObservable();
  }
  get count() {
    return this._count$.value;
  }

  @Output() cancel = new EventEmitter<boolean>();
  @Output() selection = new EventEmitter<CourseModel>();

  selectedItem: CourseModel;
  filter: FindFilter;
  searchKeyValues: any = {};
  firstItem: number = 0;

  columns: any[] = [
    { header: "Course Number", field: "courseNumber" },
    { header: "Course Name", field: "courseName" },
    { header: "Credit Hours", field: "creditHours" }
  ];

  constructor(
    private _courseService: CourseService,
    private _toastService: ToastService) {
    super();
  }

  ngOnInit() {
    this.searchKeyValues = {"Active": "true"};
  }

  onCancelClick() {
    this.cancel.emit(false);
  }

  onReloadList(event: LazyLoadEvent) {
    let sortField = "";
    switch (event.sortField) {
      case "courseNumber":
        sortField = "CourseNumber";
        break;
      case "courseName":
        sortField = "CourseName";
        break;
      case "creditHours":
        sortField = "CreditHours";
        break;
    }

    this.firstItem = event.first;
    let pageNumber = this.firstItem / event.rows;
    
    this.filter = Object.assign({}, {
      findKeys: this.searchKeyValues,
      includes: ["CourseResponders"],
      pagingInfo: {
        "pageNumber": pageNumber,
        "pageSize": event.rows
      },
      sortInfos: [
        {
          "columnName": sortField,
          "isDescending": event.sortOrder === -1 ? true : false
        }
      ] 
    });
    this.getActiveData(false);
  }

  onSearch(event) {
    if (event["CourseNumber"] != this.filter.findKeys["CourseNumber"] ||
        event["CourseName"] != this.filter.findKeys["CourseName"]) {
      this.firstItem = 0;
      this.filter.pagingInfo.pageNumber = 0;
    }
    this.searchKeyValues = Object.assign(this.searchKeyValues, event);
    this.filter = Object.assign(this.filter, {findKeys: this.searchKeyValues});
    this.getActiveData(true);
  }
    
  onSelectClick(event) {
    this.selection.emit(event);
  }

  private getActiveData(searching: boolean) {
    return new Promise<void>((resolve, reject) => {
      this.safeSubscribe(this._courseService.FindInDomain(this.filter), data => {
        this._itemList$.next(data);
        this._count$.next(data.TotalRecordCount);
        if (searching) {
          this.searchCourse.onSearchComplete();
        }
        return resolve();
      }, error => {
        this._toastService.showError(error);
        reject();
      });
    });
  }
  
}